import React, {ReactNode} from "react";
import styled from "@emotion/styled";

interface IconLinkProps {
    text: string;
    href: string;
    icon: ReactNode;
    fontSize?: string;
}

const IconLinkStyled = styled.a({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    color: "var(--color-green-dark)",
    fontSize: "16px",
    fontWeight: "bold",
    padding: "8px 16px",
    cursor: "pointer",
    transition: "color 150ms linear",
    [`:hover`]: {
        color: "#76b23a",
    }
})

function IconLink(props: IconLinkProps) {

    const { text, href, icon, fontSize } = props;

    return (
        <IconLinkStyled
            href={href}
            target="_blank"
            style={{fontSize: fontSize ? fontSize : "16px"}}>
            {text}
            {icon}
        </IconLinkStyled>
    );
}

export default IconLink;